// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import { Box, CircularProgress, Typography } from '@mui/material';
// import { getDecryptedAccessToken } from '../../../Utils/LoginUserDetails.js/LoginUserSavedDetails';

// function WenoPrescription() {
//   const [iframeUrl, setIframeUrl] = useState('');
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState('');

//   console.log("iframeUrl",iframeUrl)

// const accessToken = getDecryptedAccessToken()

//   useEffect(() => {
//     const fetchIframeUrl = async () => {
//       try {
//         const response = await axios.get('http://18.191.236.218/riteclinic-openemr/apis/default/api/wenoprescriber/25', {
//           headers: {
//             Authorization: `Bearer ${accessToken}`,
//           },
//         });

//         if (response.data) {
//             const composeUrl = "https://online.wenoexchange.com/en/NewRx/ComposeRx?useremail=chavannikitas94%40gmail.com&data=dDn2j7E3mhzbw5QN6fE2hc9QzJikl5E3wmEz1c93XZnjEFcpFGAtgw%2B6qpnla3UIZfJ2ULHHbhsEq%2BLtt5bP8Y7PqOiLmx%2FbFxXJFMzofvjJ%2FyS1AkGOlAfVuQDomQCMQBmcEmH7ZRVfn%2B7ACYEpCeRcpz1Xs3OhXHTXWgcMCDDhXTU9Un7SH6t0FLwOE%2BCYyOrDJeJVwXfpC3rfhhTcHFF7%2Bo2TB56CwUJyirRXrxqaQMPCYHWT3o%2FSuEdxjAV5I7J4FFmFcU2bYlJEWyqenKMRwCgVdrq3Q1jagGoF%2B%2FxKg%2BzA1QTPMAWmdpI4y3Jl6enjCaBcS%2FvBQaq%2B9XhcbPqZWoOAQ43J%2FQf3EQ2eOdGotxoTc%2BEu3H3gg%2FcqZ5feWrk2LGftf1nQVIuXjGgQUISO9Aj2YXvrDdiADJuShOPCzkxL8ich8NhWmLRXISjTJJ%2FaqXtBVRxnVpC3RhalLouMqMAmH3c1%2BkC0R%2BkXKl55NyxRUqfM9a3RhGq7xGrN%2B6p5XTpzY%2FVGkCsvZyUPxE333wO3vxv81DAVNdmgKh%2Bj%2Bjf8JwN%2BlUibmgneKvUuggrOiD3eNjH6ZobaPiunWJv6T9oSwzZWUPrXzmHc2zV49JuYTpdlnrQfJSbTVyUWh5pu5Qg7d2ULT6OScaUNdWR7%2BhaGTAfjOEhA4rJMJgWC054F0%2FH5LUAFDODHzZwFyEEvvlW2FO9utw9GpK1Jh3mw%2BMRLDwS7PCCA7pvD7SY%3D"
//             // const composeUrl = `https://online.wenoexchange.com/en/NewRx/ComposeRx?useremail=${encodeURIComponent(response.data.email)}}&data=dDn2j7E3mhzbw5QN6fE2hc9QzJikl5E3wmEz1c93XZnjEFcpFGAtgw%2B6qpnla3UIZfJ2ULHHbhsEq%2BLtt5bP8Y7PqOiLmx%2FbFxXJFMzofvjJ%2FyS1AkGOlAfVuQDomQCMQBmcEmH7ZRVfn%2B7ACYEpCeRcpz1Xs3OhXHTXWgcMCDDhXTU9Un7SH6t0FLwOE%2BCYyOrDJeJVwXfpC3rfhhTcHFF7%2Bo2TB56CwUJyirRXrxqaQMPCYHWT3o%2FSuEdxjAV5I7J4FFmFcU2bYlJEWyqenKMRwCgVdrq3Q1jagGoF%2B%2FxKg%2BzA1QTPMAWmdpI4y3Jl6enjCaBcS%2FvBQaq%2B9XhcbPqZWoOAQ43J%2FQf3EQ2eOdGotxoTc%2BEu3H3gg%2FcqZ5feWrk2LGftf1nQVIuXjGgQUISO9Aj2YXvrDdiADJuShOPCzkxL8ich8NhWmLRXISjTJJ%2FaqXtBVRxnVpC3RhalLouMqMAmH3c1%2BkC0R%2BkXKl55NyxRUqfM9a3RhGq7xGrN%2B6p5XTpzY%2FVGkCsvZyUPxE333wO3vxv81DAVNdmgKh%2Bj%2Bjf8JwN%2BlUibmgneKvUuggrOiD3eNjH6ZobaPiunWJv6T9oSwzZWUPrXzmHc2zV49JuYTpdlnrQfJSbTVyUWh5pu5Qg7d2ULT6OScaUNdWR7%2BhaGTAfjOEhA4rJMJgWC054F0%2FH5LUAFDODHzZwFyEEvvlW2FO9utw9GpK1Jh3mw%2BMRLDwS7PCCA7pvD7SY%3D`;
//         setIframeUrl(composeUrl);
//         } else {
//           setError('Unable to retrieve iframe URL.');
//         }
//       } catch (err) {
//         console.error('Error loading iframe URL:', err);
//         setError('Failed to load Weno prescription interface.');
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchIframeUrl();
//   }, []);

//   if (loading) {
//     return (
//       <Box display="flex" justifyContent="center" alignItems="center" height="60vh">
//         <CircularProgress />
//       </Box>
//     );
//   }

//   if (error) {
//     return (
//       <Box display="flex" justifyContent="center" alignItems="center" height="60vh">
//         <Typography color="error">{error}</Typography>
//       </Box>
//     );
//   }

//   return (
//     <Box height="90vh" width="100%">
//       <iframe
//         src={iframeUrl}
//         title="Weno ePrescription"
//         width="100%"
//         height="100%"
//         frameBorder="0"
//         style={{ border: 'none' }}
//       />
//     </Box>
//   );
// }

// export default WenoPrescription;




import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { getDecryptedAccessToken, getDecryptedData } from '../../../Utils/LoginUserDetails.js/LoginUserSavedDetails';

function WenoPrescription() {
  const [iframeUrl, setIframeUrl] = useState('');
  const [error, setError] = useState('');
const accessToken = getDecryptedAccessToken()
const LoginUserDetails = getDecryptedData()
  // Static access token for authorization (replace with your real one)
  
  useEffect(() => {
      const fetchIframeUrl = async () => {
      try {
        const userId = 25; // Your user ID (can be dynamic)
        
        const response = await axios.get(
          `http://18.191.236.218/riteclinic-openemr/apis/default/api/wenoprescriber/${LoginUserDetails.id}`,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`
            }
        }
    );
    
    const { email, provider_uid} = response.data;
    console.log("email",email)

        if (!email || !provider_uid) {
          setError('Missing required credentials');
          return;
        }

        const composeUrl = `https://online.wenoexchange.com/en/NewRx/ComposeRx?useremail=${email}&data=S+/4rbKmspdZTyjEYXtADxXLqeTQe7/kOY4c3Xe6nAHYchiZKJXi4UwGbFhNQzq9LXZmCjjSuF8xCp/zfsSZRSQUQbcW8BcRtfkL82/DS7XspCx8rUocJXhrpiD1mT7oAIcOGpIBNx35FplPV5+EA6TTDqdMyWx9jHStO9lBJ6ykKHfqNfhQvbmTztsp60ujfSNEHIRlsrHZw1xARstp3BLrwCR9jwUFUaJg+VPiRA5an0Bqf4cWqZiz+BQTy2Y+YCCiIqELj+sH2ZgxWDR7+DZMk9qXzrJ7RsVwMUrDQE/Uop2AsI3wFBWl0QMbfma5njOI1hi0tqnu4U9JO24el8ZS+/ksrqW0DNzk3JH6VT94c04wx0FNmUX/pWYt2kn7rv796yNCiSM4ZlMScHfPoM80vK+wDHRjJMjHA+IsA8cIcqQbElDUxYJzgSLJr/QHCJIYvelTjDGI/GlFDzZBQtYJfM1eb7YfNxhmoNYxmDyCVMObP4G0BIfesWFlvCMjomBlexmWz8FaQqNJwLyDh+YC4uilUo3msCaIa0+kl2SIFfSelWLbjodwdPrHNMRd9R56LVVOXcxCnegxGDDmA4onMYWxr5afo9ARqUils2UTFXqVb70AsZ+FSQhH1NeCPBOUA7Fnd9z57ko07nRGvp6tlkJnfImh5UH1Yy/w+t+yeElL7M5HyZhrLhjoLeOO`
        setIframeUrl(composeUrl);
      } catch (err) {
        console.error('Failed to load Weno iframe:', err);
        setError('Failed to load Weno iframe');
      }
    };

    fetchIframeUrl();
  }, [LoginUserDetails]);

  return (
    <div style={{ padding: '20px' }}>
      <h2>Weno Prescription Portal</h2>
      {error && <div style={{ color: 'red' }}>{error}</div>}
      {!iframeUrl && !error && <p>Loading Weno...</p>}
      {iframeUrl && (
        <iframe
          src={iframeUrl}
          title="Weno Prescription"
          width="100%"
          height="700"
          frameBorder="0"
          allowFullScreen
        />
      )}
    </div>
  );
}

export default WenoPrescription;